<template>
  <div :class="getCss('copyright-container')"  v-if="showCopyRight" :style="copyrightContainerStyle">
    <div :class="getCss('copy_wrap')">
      <div :class="getCss('copy_inner')">
        <p :class="getCss('developer')">开发者：{{gameConfig.openAccount}}</p>
        <p :class="getCss('copy_game')">
          <span :class="getCss('game-name')">{{gameConfig.gameName}} {{gameConfig.version}}</span>
          <svg
            :style="`fill: ${configurationData.color}`"
            :class="getCss('copyright-arrow')"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3211"
            width="200"
            height="200"
          >
            <path
              d="M276.755 942.936c28.497 29.315 74.739 29.315 103.307 0l367.236-378.011c28.483-29.367 28.483-76.982 0-106.291l-367.236-377.997c-28.562-29.367-74.806-29.367-103.307 0-28.546 29.325-28.546 76.929 0 106.304l315.6 324.841-315.599 324.803c-28.545 29.367-28.544 76.973 0 106.356l0 0z"
            />
          </svg>
        </p>
      </div>
    </div>
    <span :class="getCss('privacy-policy')" :style="`color: ${configurationData.policyColor}`">
      <a href="#" :style="`color: ${configurationData.policyColor}`" @click="handleOpenPrivate">隐私政策</a> |
      <a
        href="#"
        :style="`color: ${configurationData.policyColor}`"
        @click="handleOpenPermission"
      >应用权限</a>
    </span>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CCopyright',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'copyright-',
      // vuex

      init: false,
      pageConfig: {},
      gameConfig: {
        openAccount: '深圳腾讯科技有限公司',
        gameName: '游戏名',
        version: '版本号',
        netPartment: '',
      },
    };
  },
  computed: {
    showCopyRight() {
      return this.$isInEditor || this.init;
    },
    copyrightContainerStyle() {
      return {
        color: this.configurationData.color,
        background: `rgba(${parseInt(`0x${this.configurationData.backgroundColor.slice(1, 3)}`, 10)},${parseInt(`0x${this.configurationData.backgroundColor.slice(3, 5)}`, 10)},${parseInt(`0x${this.configurationData.backgroundColor.slice(5, 7)}`, 10)},${this.configurationData.opacity}`,
        ...this.styles.base,
        display: 'flex',
      };
    },
    isIOS() {
      return this.$platform.isIos;
    },
  },
  mounted() {
    console.log('configurationData= copy', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$isInEditor) return;
      this.initCopyrightGameConfig();
    },
    async initCopyrightGameConfig() {
      if (this.isIOS || !this.configurationData.gid) {
        return;
      }
      // let response = {
      //   status: 200,
      //   data: {
      //     gameName: '魂斗罗：归来',
      //     version: '1.40.83.4125',
      //     openAccount: '深圳市腾讯计算机系统有限公司',
      //     netPartment: 'https://game.qq.com/privacy_guide.shtml',
      //     copyright: '0,1,2,7,8,9,10,18,19,31',
      //   },
      // };
      const response = await this.$axiosInstance.get(`https://apps.xinyue.qq.com/Dev/authority/index?gid=${this.configurationData.gid}&_dc=${Math.random()}`);
      if (response.status === 200) {
        const { openAccount, gameName, version, netPartment } = response.data;
        this.gameConfig.openAccount = openAccount;
        this.gameConfig.gameName = gameName;
        this.gameConfig.version = version;
        this.gameConfig.netPartment = netPartment;
        this.init = true;
      } else {
        console.log('error', response);
      }
    },
    handleOpenPrivate(event) {
      event && event.stopPropagation();
      this.gameConfig.netPartment && this.$ast.openView({ url: this.gameConfig.netPartment });
    },
    handleOpenPermission(event) {
      event && event.stopPropagation();
      this.$ast.openView({
        url: `https://xinyue.qq.com/act/a20210318common/app-authority.html?gid=${this.configurationData.gid}`,
      });
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
